import { render, staticRenderFns } from "./CommunicationActivity.vue?vue&type=template&id=5b613e98&scoped=true"
import script from "./CommunicationActivity.vue?vue&type=script&lang=js"
export * from "./CommunicationActivity.vue?vue&type=script&lang=js"
import style0 from "./CommunicationActivity.vue?vue&type=style&index=0&id=5b613e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b613e98",
  null
  
)

export default component.exports